<template>
	<div>
		<script type="application/ld+json">
			{{ json }}
		</script>
	</div>
</template>
<script>
import { range } from 'lodash';
import { dayNrToString } from 'utils';

import router from 'router';

export default {
	props: {
		store: {
			type: Object,
			required: true,
		},
	},
	data () {
		return {
			dayNrToString,
		};
	},
	computed: {
		images () {
			const images = [];
			for (const image of this.store.images) {
				images.push(window.location.protocol + image.zoom);
			}
			return images;
		},
		storeRoute () {
			return router.route({
				name: 'store',
				params: {
					id: this.store.id,
					name: this.store.name,
				},
			});
		},
		storeUrl () {
			return router.routeToUrl(this.storeRoute);
		},
		json () {
			const openingHoursSpecification = [];
			for (const openingHours of this.store.regularOpenHours) {
				const from = openingHours.fromWeekday || 1;
				// When toWeekday = null then it is the same day as the from day.
				const to = openingHours.toWeekday || from;
				const dayOfWeek = range(from, to + 1).map(nr => dayNrToString(nr));

				openingHoursSpecification.push({
					'@type': 'OpeningHoursSpecification',
					dayOfWeek,
					opens: openingHours.opening,
					closes: openingHours.closing,
				});
			}

			for (const abnormalOpenHours of this.store.abnormalOpenHours) {
				openingHoursSpecification.push({
					'@type': 'OpeningHoursSpecification',
					opens: abnormalOpenHours.opening,
					closes: abnormalOpenHours.closing,
					validFrom: abnormalOpenHours.date,
					validThrough: abnormalOpenHours.date,
				});
			}
			const markup = {
				'@context': 'http://schema.org',
				'@type': 'Store',
				'@id': this.storeUrl,
				url: this.storeUrl,
				name: this.store.name,
				address: {
					'@type': 'PostalAddress',
					streetAddress: this.store.address,
					addressLocality: this.store.city,
					postalCode: this.store.zipCode,
					addressCountry: 'SE',
				},
				currenciesAccepted: 'SEK',
				openingHoursSpecification,
				geo: {
					'@type': 'GeoCoordinates',
					latitude: this.store.location.lat,
					longitude: this.store.location.lng,
				},
				telephone: '+4686736000',
				priceRange: '$$',
			};
			if (this.images.length) {
				markup.image = this.images;
			} else {
				markup.image = router.getBaseUrl() + '/android-chrome-512x512.png';
			}

			return JSON.stringify(markup);
		},
	},
};
</script>